import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import Pagination from "./Pagination";

const CustomTable = (props) => {
    const containerStyle = React.useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = React.useMemo(() => ({ height: "100%", width: "100%" }), []);

      const defaultColDef = React.useMemo(() => {
        return {
          editable: false,
          filter: true,
          flex: 1
        };
      }, []);
      const rowClassRules = React.useMemo(() => {
        return {
          "rag-red": (params) => params.data.make === "Ford",
        };
      }, []);
  return (
    <React.Fragment>
      <div className="data-table">
      <div style={containerStyle}>
        <div className="ag-theme-quartz" style={gridStyle}>
          <AgGridReact
           rowHeight={60}
          rowData={props?.rowData}
          columnDefs={props?.colDefs}
          defaultColDef={defaultColDef}
          rowClassRules={rowClassRules}
          rowSelection={"multiple"}
          suppressRowClickSelection={true}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={[5, 10, 25]}
          
          />

        </div>
        {/* <Pagination totalPages={props.totalPages} pageNo={props.pageNo} setPageNo={props.setPageNo}/> */}
      </div>
      </div>
    </React.Fragment>
  );
};
export default CustomTable;
